// // import React from "react";
// // import "./App.css";
// // import { BrowserRouter, Routes, Route } from "react-router-dom";
// // import Navigation from "./components/Navigation";
// // import Hero from "./components/Hero";
// // import Partners from "./components/Partners";
// // import CtaSection from "./components/CtaSection";
// // import Features from "./components/Features";
// // import DetailedFeatures from "./components/DetailedFeatures";
// // import Stats from "./components/Stats";
// // import Integrations from "./components/Integrations";
// // import Pricing from "./components/Pricing";
// // import Testimonials from "./components/Testimonials";
// // import FAQ from "./components/FAQ";
// // import FinalCta from "./components/FinalCta";
// // import Footer from "./components/Footer";
// // import AdminPanel from "./pages/AdminPanel";
// // import { Toaster } from "./components/ui/toaster";

// // const HomePage = () => {
// //   return (
// //     <>
// //       <Navigation />
// //       <Hero />
// //       <Partners />
// //       <CtaSection />
// //       <Features />
// //       <DetailedFeatures />
// //       <Stats />
// //       <Integrations />
// //       <Pricing />
// //       <Testimonials />
// //       <FAQ />
// //       <FinalCta />
// //       <Footer />
// //     </>
// //   );
// // };

// // function App() {
// //   return (
// //     <div className="App">
// //       <BrowserRouter>
// //         <Routes>
// //           <Route path="/" element={<HomePage />} />
// //           <Route path="/admin" element={<AdminPanel />} />
// //         </Routes>
// //       </BrowserRouter>
// //       <Toaster />
// //     </div>
// //   );
// // }

// // export default App;

// import React from "react";
// // HAPUS import Navigation
// import Hero from "@/components/Hero"; // DIUBAH
// import Partners from "@/components/Partners"; // DIUBAH
// import CtaSection from "@/components/CtaSection"; // DIUBAH
// import Features from "@/components/Features"; // DIUBAH
// import DetailedFeatures from "@/components/DetailedFeatures"; // DIUBAH
// import Stats from "@/components/Stats"; // DIUBAH
// import Integrations from "@/components/Integrations"; // DIUBAH
// import Pricing from "@/components/Pricing"; // DIUBAH
// import Testimonials from "@/components/Testimonials"; // DIUBAH
// import FAQ from "@/components/FAQ"; // DIUBAH
// import FinalCta from "@/components/FinalCta"; // DIUBAH
// import Footer from "@/components/Footer"; // DIUBAH
// import ColorBends from "@/components/ColorBends"; // DIUBAH
// import CardNav from "@/components/CardNav"; // DIUBAH
// import "@/App.css"; 

// // Ini adalah komponen yang membungkus semua halaman utama Anda
// const HomePageLayout = () => {
//   // Definisikan item menu untuk CardNav
//   const navItems = [
//     {
//       label: "Products",
//       bgColor: "#111111", // Warna gelap
//       textColor: "#fff",
//       links: [
//         { label: "Features", href: "#features", ariaLabel: "View Features" },
//         { label: "Integrations", href: "#integrations", ariaLabel: "View Integrations" }
//       ]
//     },
//     {
//       label: "Navigate",
//       bgColor: "#222222", // Sedikit lebih terang
//       textColor: "#fff",
//       links: [
//         { label: "Home", href: "#hero", ariaLabel: "Go to Home" },
//         { label: "Pricing", href: "#pricing", ariaLabel: "View Pricing" }
//       ]
//     },
//     {
//       label: "Support",
//       bgColor: "#333333", // Paling terang
//       textColor: "#fff",
//       links: [
//         { label: "FAQ", href: "#faq", ariaLabel: "Read FAQ" },
//         { label: "Testimonials", href: "#testimonials", ariaLabel: "Read Testimonials" }
//       ]
//     }
//   ];

//   return (
//     // 'bg-background' memberi warna hitam solid di belakang animasi
//     <div className="dark bg-background text-foreground">
//       {/* Background Component */}
//       <div className="fixed top-0 left-0 w-full h-full z-0">
//         <ColorBends
//           colors={["#ff5c7a", "#8a5cff", "#0C68DF", "#069B2D"]}
//           rotation={0}
//           autoRotate={0}
//           speed={0.5}
//           scale={0.3}
//           frequency={2}
//           warpStrength={0.87}
//           mouseInfluence={1}
//           parallax={0.6}
//           noise={0}
//           transparent={false} // Dibuat solid
//         />
//       </div>

//       {/* GANTI Navigation LAMA dengan CardNav BARU */}
//       <CardNav
//         logo="https://pub-3c9608891c7244c2a3a8c20309745abf.r2.dev/5a467318-6398-432a-bbce-60cba851785c.png"
//         logoAlt="Business Solution"
//         items={navItems}
//         baseColor="transparent" // Diatur oleh CSS .card-nav
//         menuColor="#fff" // Warna ikon hamburger (putih)
//         buttonBgColor="#fff" // Warna tombol CTA (putih)
//         buttonTextColor="#000" // Warna teks tombol CTA (hitam)
//         ctaText="Start Now" // Teks tombol dari mockData lama
//         ease="power3.out"
//       />

//       {/* Konten Halaman */}
//       {/* "relative z-10" penting agar konten tampil di atas background */}
//       {/* TAMBAHKAN 'pt-32' agar konten tidak tertutup nav baru */}
//       <main className="relative z-10 pt-32">
//         <Hero />
//         <Partners />
//         <CtaSection />
//         <Features />
//         <DetailedFeatures />
//         <Stats />
//         <Integrations />
//         <Pricing />
//         <Testimonials />
//         <FAQ />
//         <FinalCta />
//         <Footer />
//       </main>
//     </div>
//   );
// };

// export default HomePageLayout;

import React from "react";
import "@/App.css"; // Tetap impor App.css agar animasi berjalan
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Impor halaman-halaman Anda
import HomePageLayout from "@/pages/HomePageLayout"; // Menggunakan layout dari folder pages
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "@/components/ui/toaster"; // Impor Toaster untuk notifikasi

// Komponen App sekarang berfungsi sebagai Router
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Rute untuk Halaman Utama */}
          <Route path="/" element={<HomePageLayout />} />
          
          {/* Rute untuk Halaman Admin */}
          <Route path="/admin" element={<AdminPanel />} />

          {/* Anda bisa tambahkan rute login di sini jika ada */}
          {/* <Route path="/admin/login" element={<LoginPage />} /> */}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;